import type { FormEvent, ReactNode } from 'react';
import type { ValidationErrors } from '@/types';

export const FormOrientation = {
  Block: 'block',
  Inline: 'inline',
} as const;

export type FormOrientation =
  (typeof FormOrientation)[keyof typeof FormOrientation];

export interface FormProps {
  children: ReactNode;
  className?: string;
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
  orientation?: FormOrientation;
  validationErrors?: ValidationErrors;
  withLabels?: boolean;
}
